import lazy from '@fatso83/retry-dynamic-import/react-lazy';
import { Suspense } from 'react';
import type { FieldRendererProps } from '../types';

const CalculatedField = lazy(() => import('../../CalculatedField'));

export function CalculatedFieldWrapper({ field, allFields, isUnsaved }: FieldRendererProps) {
  const value = field.values.length > 0 ? field.values[0] : field.value;

  return (
    <Suspense fallback={null}>
      <CalculatedField label={field.label} value={value} fields={allFields} type={field.type} isUnsaved={isUnsaved} />
    </Suspense>
  );
}
